module.exports = __webpack_public_path__ + "static/img/32.ad64175.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/32.png
// module id = rukc
// module chunks = 0